import { redirect } from "@tanstack/react-router";
import { createMiddleware } from "@tanstack/react-start";

import { getUserFromSession } from "@onesolution/utils";

export const authMiddleware = createMiddleware({ type: "function" }).server(
	async ({ next }) => {
		const user = await getUserFromSession();

		if (!user || !user.isAuthenticated) {
			throw redirect({ to: "/login" });
		}

		return next({ context: { user } });
	},
);
